(() => {
  
    const card_products = document.querySelectorAll('.card--product');
    const main_product = document.querySelector('.product .product-info');
    const quantities_map = new Map();
  
    async function requestCartHtmlAndUpdate() {
      const cart_drawer = document.getElementById('cart-drawer');
      if(cart_drawer){
        cart_drawer.refreshCartDrawer();
      }else{
        try {
          const req = await fetch('/?sections=header');
          if(!req.ok) return false;
          const json = await req.json();
          const header = json.header;
          const parser = new DOMParser();
          const html = parser.parseFromString(header, 'text/html');
          const cart_bubble = html.getElementById('cart-icon-bubble');
          const theme_bubble = document.getElementById('cart-icon-bubble');
          theme_bubble.replaceWith(cart_bubble);
          return true;
        } catch(error) {
          console.error('Could not update the cart HTML ', error);
          return false;
        }
      }
    }
  
    async function requestUpdateCart() {
      const updates = Object.fromEntries(quantities_map);
      try {
        const req = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        });
        if(!req.ok) {
          const responseData = await req.json();
          console.error('Cart could not be updated: '+ responseData.message);
          return { ok: false, message: responseData.message };
        }
        return { ok: true, message: 'Cart updated successfully' };

      } catch(error) {
        console.error('Cart could not be updated, ', error);
        return { ok: false, message: 'Cart could not be updated' };
      }
    }
  
    async function updateCart() {
      // We send the data to Shopify.
      const success = await requestUpdateCart();
      if(!success.ok) {
        console.error('Something went wrong trying to update the cart.');
        return success.message;
      }
      // Now we need to visually update the cart.
      await requestCartHtmlAndUpdate();
    }

    function bindAddToCartClickEvent(add_to_cart_btn) {
        add_to_cart_btn.addEventListener('click', (event) => {
            event.preventDefault();
            const upng_buy_update_buttons = add_to_cart_btn.closest('upng-buy-update-buttons');
            const variantId = upng_buy_update_buttons.getAttribute('data-productid');
            const quantityInput = upng_buy_update_buttons.querySelector('input[name="quantity"]');
            var quantity =  quantityInput ? parseInt(quantityInput.value) : 1;

            quantities_map.set(parseInt(variantId), quantity);
            add_to_cart_btn.classList.add('is-loading');
            add_to_cart_btn.disabled = true;

            updateCart().then((message) => {
                quantities_map.clear();
                const alertElement = upng_buy_update_buttons.querySelector('.alert');
                if (alertElement) {
                    alertElement.hidden = !message;
                    alertElement.innerHTML = message || '';
                }
                if(!message) add_to_cart_btn.classList.add('is-success');
                add_to_cart_btn.disabled = false;
                setTimeout(() => {
                    add_to_cart_btn.classList.remove('is-loading', 'is-success');
                }, 1400);
            });
        });
    }

    function bindProductQuantityChangeEvent(product_quantity_input,parent) {
        let product_info_price = parent.querySelector('.product-card__price') || parent.querySelector('.product-info__price');
        
        const unit_price_elem = product_info_price.querySelector('.upng_precio_desde .price__current');
        if (!unit_price_elem) return;
        
        const unit_price = parseInt(unit_price_elem.getAttribute('data-unit-price'))/100;
        product_quantity_input.addEventListener('change', (e) => {
            e.preventDefault();
            // Vamos a intentar obtener los descuentos por tramos.
            const variant_discount_quantity_divs = product_info_price.querySelectorAll('[product-discount-quantity]');
        
            let discount_fail = true;
            if(variant_discount_quantity_divs.length > 0) {
                let last_valid_div;
                for(let i = 0; i < variant_discount_quantity_divs.length; i++) {
                const discount_quantity_div = variant_discount_quantity_divs[i];
                discount_quantity_div.style.display = 'none';
                const discount_min_quantity = discount_quantity_div.getAttribute('product-discount-quantity');
                const discounted_price = discount_quantity_div.getAttribute('product-discounted-price');
                if(discount_min_quantity <= parseInt(product_quantity_input.value)) {
                    unit_price_elem.setAttribute('data-unit-price', discounted_price);
                    const full_price = (parseFloat(discounted_price) / 100).toFixed(2).replace('.', ',');
                    const [euros, cents] = full_price.split(',');
                    unit_price_elem.innerHTML = `${euros}<sup>${cents}€</sup>`;
                    last_valid_div = discount_quantity_div;
                    discount_fail = false;
                } else {
                    break;
                }
                }
                if(last_valid_div) last_valid_div.style.display = 'flex'; 
            }
            if(discount_fail) {
                const unit_price_elem = product_info_price.querySelector('.upng_precio_desde [data-unit-price]');
                if(unit_price_elem) {
                    unit_price_elem.setAttribute('data-unit-price', unit_price * 100);
                    const full_price = unit_price.toFixed(2).replace('.', ',');
                    const [euros, cents] = full_price.split(',');
                    unit_price_elem.innerHTML = `${euros}<sup>${cents}€</sup>`;
                }
            }
      
        });
        if (product_quantity_input.value > 0) product_quantity_input.dispatchEvent(new Event('change'));
        
    }
    function bindProductEvents(productElement) {
        const add_to_cart_btn = productElement.querySelector('.upng_quick_update__add-to-cart');
        if (add_to_cart_btn) bindAddToCartClickEvent(add_to_cart_btn);

        const product_quantity_input = productElement.querySelector('.qty-input__input');
        if (product_quantity_input) bindProductQuantityChangeEvent(product_quantity_input, productElement);
    }
    
    if(card_products.length){
      card_products.forEach(bindProductEvents);

      if ('MutationObserver' in window) {
          this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              // Add event listener to new buttons
              mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  node.querySelectorAll('.card--product').forEach(bindProductEvents);
                }
              });

            });
          });
          // Start observing changes to the DOM
          this.observer.observe(document.body, { childList: true, subtree: true });
        }
      }

      if(main_product) {
        bindProductEvents(main_product);
      }

      
  })();